export function isNumberStr(str) {
    return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(str)
}

export const dateTimeFormat = {
    date: "yyyy-MM-dd",
    week: "yyyy 第 WW 周",
    month: "yyyy-MM",
    year: "yyyy",
    datetime: "yyyy-MM-dd HH:mm:ss",
    daterange: "yyyy-MM-dd",
    monthrange: "yyyy-MM",
    datetimerange: "yyyy-MM-dd HH:mm:ss",
}

export const dateTypeOptions = [
    {
        label: "日(date)",
        value: "date",
    },
    {
        label: "周(week)",
        value: "week",
    },
    {
        label: "月(month)",
        value: "month",
    },
    {
        label: "年(year)",
        value: "year",
    },
    {
        label: "日期时间(datetime)",
        value: "datetime",
    }
]
export const dateRangeTypeOptions = [
    {
        label: "日期范围(daterange)",
        value: "daterange",
    },
    {
        label: "月范围(monthrange)",
        value: "monthrange",
    },
    {
        label: "日期时间范围(datetimerange)",
        value: "datetimerange",
    }
]

export const defaultActiveData = {
    // 组件的自定义配置
    typeId: "INPUT",
    __config__: {
        label: "单行文本",
        labelWidth: null,
        showLabel: true,
        changeTag: true,
        tag: "el-input",
        tagIcon: "input",
        defaultValue: undefined,
        displayType: true,
        required: false,
        layout: "colFormItem",
        span: 24,
        document: "https://element.eleme.cn/#/zh-CN/component/input",
        showRegList: true,
        // 正则校验规则
        regList: [],
        valueType: 'String',
    },
    // 组件的插槽属性
    __slot__: {
        prepend: "",
        append: "",
    },
    // 其余的为可直接写在组件标签上的属性
    placeholder: "请输入",
    style: { width: "100%" },
    clearable: true,
    "prefix-icon": "",
    "suffix-icon": "",
    maxlength: null,
    "show-word-limit": false,
    readonly: false,
    disabled: false,
    valueType: 'String',
    props: {}
}